import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useGetTagsQuery } from "../../../../__generated__/api";
import { TicketItem } from "../../../../contexts/ticket-state";
import FilterPanel from "../../../filters/FilterPanel";
import Badge from "../../../theme/badge/Badge";
import EditableLabel from "../editable-label/EditableLabel";
import Styles from "./Tags.module.scss";
import Text from "../../../theme/text/Text";
import { LoggingHandler } from "../../../../contexts/logging/LoggingContext";

const LOADING_TAGS = [
    "horse",
    "potato",
    "stapler",
];
const AI_TAGS_FIELD = "urn:fq:artificial-intelligence-field:tags";

export default function Tags({
    ticket, onChange, className, metricPathPrefix,
}: {
    ticket: TicketItem;
    onChange?: (tags: string[]) => void;
    className?: string;
    metricPathPrefix: string[];
}) {
    const { data, loading: isLoading } = useGetTagsQuery();
    const [selectedTags, setTags] = useState(ticket.ticket?.tags ?? []);

    useEffect(() => {
        if (ticket.ticket?.tags && !ticket.ticket.tags.equals(selectedTags)) {
            setTags(ticket.ticket.tags);
        }
    }, [ticket.ticket?.tags]);

    const tagList = selectedTags.map(tag => (
        <Badge key={tag} variant="gray">
            {tag}
        </Badge>
    ));

    if (!onChange) {
        return <div className={className}>{tagList}</div>;
    }

    const aiTags = ticket.ticket.artificialIntelligence?.values?.find(field => field.id === AI_TAGS_FIELD)?.value?.options;

    const menu = () => (
        <FilterPanel
            isMulti
            searchMinimum={10}
            className={isLoading ? "loading" : ""}
            categories={(isLoading ? LOADING_TAGS : data?.settings?.customization?.tags)?.map(tag => ({
                label: tag,
                value: tag,
            })) ?? []}
            selectedCategories={new Set(selectedTags)}
            onSelected={selected => {
                setTags(Array.from(selected));
                LoggingHandler.instance.metric([...metricPathPrefix, "change"]);
            }}
        />
    );

    return (

        <EditableLabel
            placement="bottom"
            hideStyle="visibility"
            menu={menu}
            buttonTitle={`Selected tags: ${selectedTags.join(", ")}`}
            onHide={() => onChange(selectedTags)}
            buttonClassName={classNames(Styles["edit-button"], "multiline")}
            placeholder="Add Tag"
            className={classNames(Styles.tags, className)}
            onAiClick={aiTags?.isNotEmpty && selectedTags.isEmpty ? () => {
                onChange(aiTags);
                LoggingHandler.instance.metric([...metricPathPrefix, "ai-selected"]);
            } : undefined}
            aiBody={(
                <div>
                    <Text as="span" textVariant="body-2-semibold" colorVariant="text-link">AI Detected Tags: </Text>
                    <Text as="span" textVariant="body-2-regular">{aiTags?.join(", ")}</Text>
                </div>
            )}
        >
            {tagList.isNotEmpty ? tagList : undefined}
        </EditableLabel>

    );
}

Tags.defaultProps = {
    onChange: undefined,
    className: "",
};
